import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { SocialAuthService } from "../../services/socialAuth.service";
import { catchError, exhaustMap, map, of } from "rxjs";
import { userLoginAction } from "../actions/static.actions";

@Injectable()
export class StaticEffect {
      private actions$ = inject(Actions);
      private authService = inject(SocialAuthService);
    
      userLogin$ = createEffect(() =>
        this.actions$.pipe(
          ofType(userLoginAction.loadUserLogin),
          exhaustMap((data:any) =>
            {
             return this.authService.loginUser(data.body).pipe(
              map((data) => userLoginAction.loadUserLogin({ status: 'success', data })),
              catchError((error) =>
                of(userLoginAction.loadUserLogin({ status: 'failure', error }))
              )
            )}
          )
        )
      );
}
